import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleSortIcon } from 'Images';
import { useDictionary, useIsDesktop } from 'Hooks';

interface ISortAndCountRow {
  count: number;
  sort: () => void;
  sortingOrder: boolean;
}

export const SortAndCountRow = ({
  count,
  sort,
  sortingOrder,
}: ISortAndCountRow) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const dictionaryUpdates = useDictionary(Dictionary, DICTIONARY.Updates);
  const isDesktop = useIsDesktop();

  const sortIconRotation = sortingOrder ? '180deg' : '0deg';
  const sortButtonText = dictionary.sort(!sortingOrder);

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Typography variant='body3'>
        {dictionaryUpdates.filterCount(count)}
      </Typography>
      <Button
        variant='textBtn'
        onClick={sort}
        disableTouchRipple
        sx={{
          textDecoration: 'none',
          '&:hover': { background: 'transparent', textDecoration: 'underline' },
        }}
        aria-checked={sortingOrder}
      >
        <Avatar
          alt=''
          src={PurpleSortIcon}
          sx={{
            marginRight: '5px',
            width: isDesktop ? '26px' : '24px',
            height: isDesktop ? '26px' : '24px',
            rotate: sortIconRotation,
            transition: 'rotate 0.3s ease',
          }}
        />
        <Typography variant='body2' color='primary' aria-live='assertive'>
          {sortButtonText}
        </Typography>
      </Button>
    </Stack>
  );
};
